/*=========================================================================================
  File Name: moduleFonction.js
  Description: Calendar Module
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import state from './moduleFonctionState.js'
import mutations from './moduleFonctionMutations.js'
import actions from './moduleFonctionActions.js'
import getters from './moduleFonctionGetters.js'

export default {
  isRegistered: false,
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}

